import { render, staticRenderFns } from "./UpdatePwa.vue?vue&type=template&id=322389d0&"
import script from "./UpdatePwa.vue?vue&type=script&lang=js&"
export * from "./UpdatePwa.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePwa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports